import { showNotification } from "@/entities/notification"
import { registerNotification } from "@/shared/api/websocket"
import { vpnKeys } from "../model/keys"

registerNotification("vpn_gift", {
	handle: ({ notification_id }, ctx) => {
		showNotification({
			type: "silent",
			placement: null,
			origin: "server",
			notificationId: notification_id,
			name: "vpn_gift",
		})
		ctx.queryClient.invalidateQueries({ queryKey: vpnKeys.key(ctx.userId) })
	},
	route: () => ({ to: "/profile" }),
	routePopup: null,
})
